import { render, staticRenderFns } from "./PosInvoicesTaxRefundAdd.vue?vue&type=template&id=6fee0602&scoped=true&"
import script from "./PosInvoicesTaxRefundAdd.vue?vue&type=script&lang=js&"
export * from "./PosInvoicesTaxRefundAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fee0602",
  null
  
)

export default component.exports